import type { IconSvgObject } from './types';

const DnaOffIcon: IconSvgObject = [
  ["path", { d: "M8.5 22C9 21.5 9.5 20.5 9.5 18M8.6671 15.3336C7.33381 10.0004 8.33378 9.00042 8.6671 8.6671M8.6671 15.3336C3.33394 14.0003 2.66664 14.6663 2 15.3329M8.6671 15.3336C14.0003 16.6668 14.9996 15.6662 15.3329 15.3329M22 8.6671C21.3334 9.33375 20.6667 10.0004 15.3336 8.6671M15.3336 8.6671C14.534 8.4672 13.8318 8.31976 13.2146 8.21464M15.3336 8.6671C15.5334 9.46669 15.6809 10.1689 15.786 10.786M15.3329 2C15 2.5 14.5 3.5 14.5 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default DnaOffIcon;
